import { __read, __spread } from "tslib";
import { formatValue as valueFormatter, calculateTotalValue, } from '@keen.io/charts-utils';
import { KEEN_KEY } from '@keen.io/parser';
import { calculatePercent } from '../../utils';
import { VALUE, PERCENTAGE_VALUE } from '../../constants';
export var categoricalTransformation = function (data, keys, formatValue, dataSeriesGroups, includePercentageStack) {
    var columns = __spread(dataSeriesGroups, [
        VALUE
    ], (includePercentageStack ? [PERCENTAGE_VALUE] : []));
    var rows = [];
    var isMultiGroup = dataSeriesGroups.length > 1;
    data.forEach(function (item) {
        var dataSeriesTotal = calculateTotalValue([item], KEEN_KEY, keys);
        rows.push.apply(rows, __spread(keys.map(function (keyName) { return __spread((isMultiGroup ? [item[KEEN_KEY], keyName] : [keyName]), [
            valueFormatter(item[keyName], formatValue)
        ], (includePercentageStack
            ? [calculatePercent(item[keyName], dataSeriesTotal) + "%"]
            : [])); })));
    });
    return __spread([columns], rows);
};
